module.exports = __webpack_public_path__ + "img/PizzaTeilen-NÖÖ.d3a0ec98.jpg";